import { inject, ModuleWithProviders, NgModule, PLATFORM_ID } from '@angular/core';
import { RecaptchaService } from './recaptcha.service';
import { isPlatformBrowser } from '@angular/common';
import { RECAPTCHA_INSTANCE, RECAPTCHA_OPTIONS, RecaptchaFactoryService } from './recaptcha-factory.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { RecaptchaOptions } from './recaptcha.model';

@NgModule({
  providers: [RecaptchaService, RecaptchaFactoryService],
})
export class RecaptchaModule {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly options = inject(RECAPTCHA_OPTIONS, { optional: true });
  private readonly recaptchaFactoryService = inject(RecaptchaFactoryService);

  private static readonly recaptcha: BehaviorSubject<ReCaptchaV2.ReCaptcha | null> =
    new BehaviorSubject<ReCaptchaV2.ReCaptcha | null>(null);
  private static initialized = false;

  constructor() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (!this.options) {
      throw new Error(
        `Recaptcha module has not been initialized. Make sure to call RecaptchaModule.init(...) in your root module.`
      );
    }

    if (!RecaptchaModule.initialized) {
      this.recaptchaFactoryService.load().subscribe({
        next: (instance) => {
          RecaptchaModule.recaptcha.next(instance);
        },
        error: () => {
          console.error('Error loading recaptcha script');
        },
      });
      RecaptchaModule.initialized = true;
    }
  }

  static init(options$: Observable<RecaptchaOptions>): ModuleWithProviders<RecaptchaModule> {
    return {
      ngModule: RecaptchaModule,
      providers: [
        { provide: RECAPTCHA_OPTIONS, useValue: options$ },
        { provide: RECAPTCHA_INSTANCE, useFactory: () => RecaptchaModule.recaptcha.asObservable() },
      ],
    };
  }
}
